module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"SMS Rates","description-1":"Sending SMS is charged by the telephone operators and has a cost of","description-2":"for each message sent"},"pt-BR":{"title":"Tarifas de SMS","description-1":"O envio de SMS é tarifado pelas operadoras de telefonia e tem um custo de","description-2":"por mensagem enviada"}}')
  delete Component.options._Ctor
}
